module.exports = __webpack_public_path__ + "static/media/full-outer-join-icon.735f43eb.svg";